import { configureStore, Middleware } from '@reduxjs/toolkit';
import { ErrorActions, errorReducer, IErrorState } from './errorHandling';
import { errorMiddleware } from 'shared/metrics/error-reporter';

export type RootAction = ErrorActions;
export interface IAppState {
  app: string;
  error: IErrorState;
}

const windowIfDefined = typeof window === 'undefined' ? null : (window as any);
const devToolsExtension =
  windowIfDefined && (windowIfDefined.__REDUX_DEVTOOLS_EXTENSION__ as () => any);

export function configureAppStore(
  useAppInsights: boolean = true,
  middlewares: Middleware[] = [],
  defaultState: IAppState
) {
  const store = configureStore<IAppState>({
    reducer: {
      app: (state = 'Patient App') => state,
      error: errorReducer,
    },
    middleware: getDefaultMiddleware => {
      const appliedMiddlewares = getDefaultMiddleware();
      if (useAppInsights) {
        appliedMiddlewares.push(errorMiddleware());
      }
      return appliedMiddlewares;
    },
    devTools: devToolsExtension !== undefined,
    preloadedState: defaultState,
  });

  return store;
}
